module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category"
  }, [(_vm.cache.categories[_vm.categoryId]) ? _c('label', {
    staticClass: "custom-control custom-checkbox category-name",
    class: {
      highlighted: _vm.filteredIds[0] === _vm.categoryId
    }
  }, [_c('input', {
    staticClass: "custom-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.selection[_vm.categoryId]
    },
    on: {
      "click": function($event) {
        _vm.$emit('selected', {
          id: _vm.categoryId,
          value: $event.target.checked
        })
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-control-indicator"
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-control-description"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.cache.categories[_vm.categoryId].name) + "\n\t\t")])]) : _vm._e(), _vm._v(" "), ((_vm.childrenToShow.length || !this.expanded) && _vm.cache.categories[_vm.categoryId]) ? _c('button', {
    staticClass: "category-button pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.expanded = !_vm.expanded
      }
    }
  }, [_c('i', {
    class: 'fa-fw fa fa-chevron-' + (_vm.expanded ? 'down' : 'right') + ' text-muted'
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.childrenToShow), function(category) {
    return [_c('category-recursive', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.expanded),
        expression: "expanded"
      }],
      attrs: {
        "category-id": category.id,
        "filtered-ids": _vm.filteredIds,
        "only-filtered": _vm.onlyFiltered,
        "selection": _vm.selection
      },
      on: {
        "selected": function($event) {
          _vm.$emit('selected', $event)
        }
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b5591100!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/base/category/recursive.vue
// module id = 669
// module chunks = 1